import type {
  Breakpoint as MuiBreakpoint,
  Breakpoints,
} from '@mui/material/styles';

export type Breakpoint = MuiBreakpoint;

export interface MaxWidths {
  keys: Breakpoint[];
  values: Breakpoints['values'];
  width: (key: Breakpoint) => string;
  unit: string;
}

export interface MaxWidthsConfig {
  keys: Breakpoint[];
  values: Breakpoints['values'];
  unit: string;
}

const defaults: MaxWidthsConfig = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 20,
    sm: 20,
    md: 42,
    lg: 72,
    xl: 72,
  },
  unit: 'rem',
};

const createMaxWidths = (mw = defaults): MaxWidths => ({
  ...mw,
  width: (breakpoint: Breakpoint) => `${mw.values[breakpoint]}${mw.unit}`,
});

export { createMaxWidths };
